import { ChangeEvent, useEffect } from "react";
import { NumberInput, RaRecord, SelectInput, TextInput, maxValue, minValue, required } from "react-admin";
import { useFormContext } from "react-hook-form";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";
import { siteCountryChoices } from "shared/enums/reactAdminChoices";

export const CountryInput = () => {
  const { setValue } = useFormContext();
  const handleChange = (event: ChangeEvent<HTMLInputElement> | RaRecord) => {
    setValue("site_ids", "");
    setValue("country", event.target.value);
  };

  return <SelectInput source="country" choices={siteCountryChoices} validate={required()} onChange={handleChange} />;
};

type GroupDataInputProps = {
  siteCount: number;
  source: string;
  label: string;
  isMin?: boolean;
};

export const GroupDataInput = ({ siteCount, source, label, isMin }: GroupDataInputProps) => {
  const { setValue } = useFormContext();
  const numberValidations = isMin ? maxValue(-1) : minValue(1);
  const BASE_CAPACITY = 1.25 * 1.1;

  useEffect(() => {
    const newValue = siteCount * BASE_CAPACITY;
    setValue(source, isMin ? -newValue : newValue);
  }, [siteCount, setValue, isMin, source, BASE_CAPACITY]);

  return <NumberInput source={source} label={label} validate={(required(), numberValidations)} />;
};

export const CodeTmInput = ({ type, code }: { type: string; code: string }) => {
  const isEdr = type === FranceGroupTypeEnum.rte_edr;

  return isEdr ? <TextInput source="code_tm" label={"Code TM"} validate={required()} defaultValue={code} /> : <></>;
};
